import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import { HashRouter as Router } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { onCLS, onINP, onLCP } from 'web-vitals';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error("Could not find root element");

// Create or reuse root to prevent "container already passed to createRoot" warning
const root = (window as any)._reactRoot || ReactDOM.createRoot(rootElement);
if (!(window as any)._reactRoot) (window as any)._reactRoot = root;

root.render(
  <React.StrictMode>
    <AuthProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <App />
      </Router>
    </AuthProvider>
  </React.StrictMode>
);

// Report Web Vitals to console (can be sent to analytics endpoint)
onCLS(console.log);
onINP(console.log);
onLCP(console.log);
